import { css } from 'styled-components';

const titleShared = css`
  border-radius: 4px 4px 0 0;
  font-size: 2.4rem;
  font-weight: 600;
  padding: 1.6rem;
  text-align: center;
`;

export const components = {
  divider: css`
    background-color: #cccccc;
    border: none;
    height: 0.1rem;
    width: 100%;
  `,
  keypad: {
    popupContainer: css`
      background-color: ${({ theme }) => theme.colors.white};
      border-radius: ${({ theme }) => theme.borderRadius.large};
      box-shadow: ${({ theme }) => theme.shadows.drop};
      padding: 1.2rem;
      width: 27rem;
      z-index: ${({ theme }) => theme.layers.keypads};
    `
  },
  parlayBuilder: {
    subitem: {
      selected: css`
        border-radius: 2.2rem;
        font-weight: 600;
      `
    }
  },
  title: {
    error: css`
      ${titleShared}
      background-color: #ea1319;
      color: #ffffff;
    `,
    expired: css`
      ${titleShared}
      background-color: #000000;
      color: #ffffff;
    `,
    neutral: css`
      ${titleShared}
      background-color: #dadada;
      color: #343840;
    `,
    success: css`
      ${titleShared}
      background-color: #1bc47d;
      color: #343840;
    `,
    warning: css`
      ${titleShared}
      background-color: #fcb514;
      color: #343840;
    `
  },
  contestModal: {
    green: '#14AF6E',
    red: '#EA1319',
    grey: '#343840'
  },
  header: {
    button: '#000000',
    textColor: '#343840',
    rewardsCard: {
      button: '#FCB514',
      border: 'linear-gradient(#FCB514 35%, #FFFFFF 50%, #F2CE7C 65%)'
    },
    playableBalance: {
      borderColor: 'linear-gradient(#86CDB0 35%, #ECDF89 50%, #14AF6E 65%)',
      underline: '#1BC47D'
    },
    subTotal: {
      divisor: '#E5E5E5',
      zero: {
        backgroundColor: '#8D8D8D',
        underline: 'transparent',
        buttonColors: {
          backgroundColor: 'transparent',
          color: '#FFFFFF'
        },
        color: '#FFFFFF'
      },
      collect: {
        backgroundColor: 'linear-gradient(#C37C7C 35%, #861A97 50%, #FF0000 65%)',
        underline: '#EA1319',
        buttonColors: {
          backgroundColor: '#EA1319',
          color: '#FFFFFF'
        },
        color: '#FFFFFF'
      },
      payout: {
        backgroundColor: 'linear-gradient(#86CDB0 35%, #ECDF89 50%, #14AF6E 65%)',
        underline: '#1BC47D',
        buttonColors: {
          backgroundColor: '#1BC47D',
          color: '#343840'
        },
        color: '#FFFFFF'
      },
      tickets: {
        backgroundColor: 'linear-gradient(#FCB514 35%, #FFFFFF 50%, #F2CE7C 65%)',
        underline: '#FCB514',
        buttonColors: {
          backgroundColor: '#FCB514',
          color: '#343840'
        },
        color: '#FFFFFF'
      }
    }
  },
  wallet: {
    summary: '#e4f9ff',
    red: {
      background: '#fff1f2',
      text: '#ea1319'
    }
  },
  scrollBar: {
    background: '#7a7f82'
  }
};
